import localforage from 'localforage';
import util from 'util'

function clear_data() {
    return new Promise((resolve, reject) => {
        localforage.clear().then(function (value) {
            resolve(value)
        }).catch(function (err) {
            reject(err)
        });
    })
}

function set_login_result(payload) {
    return new Promise((resolve, reject) => {
        localforage.setItem('login_result', payload).then(function (value) {
            resolve(value)
        }).catch(function (err) {
            reject(err)
        });
    })
}

function get_login_result() {
    return new Promise((resolve, reject) => {
        localforage.getItem('login_result').then(function (payload) {
            resolve(payload)
        }).catch(function (err) {
            reject(err)
        });
    })
}

function set_list_services(payload) {
    return new Promise((resolve, reject) => {
        localforage.setItem('list_service', payload).then(function (value) {
            resolve(value)
        }).catch(function (err) {
            reject(err)
        });
    })
}

function get_list_services() {
    return new Promise((resolve, reject) => {
        localforage.getItem('list_service').then(function (payload) {
            resolve(payload)
        }).catch(function (err) {
            reject(err)
        });
    })
}

function get_product(s_type) {
    return new Promise((resolve, reject) => {
        localforage.getItem('list_service').then(function (payload) {
            payload.map(function(service, i) {
                if (service.menu_type == s_type) {
                    resolve(service.list_products)
                }
            })
            resolve("")
        }).catch(function (err) {
            reject(err)
        });
    })
}

function get_denom_by_prefix(s_type, p_prefix) {
    return new Promise((resolve, reject) => {
        localforage.getItem('list_service').then(function (payload) {
            payload.map(function(service, i) {
                if (service.menu_type == s_type) {
                    let products = service.list_products
                    products.map(function(product, j) {
                        let id = product.product_id
                        let prefixs = product.telco_prefix
                        let denoms = product.list_denoms
                        prefixs.map(function(prefix, k) {
                            if (p_prefix.startsWith(prefix)) {
                                resolve({"product_id": id, "denoms": denoms})
                            }
                        })
                    })
                }
            })
            resolve("")
        }).catch(function (err) {
            reject(err)
        });
    })
}

function get_denom_by_product(s_type, p_type) {
    return new Promise((resolve, reject) => {
        localforage.getItem('list_service').then(function (payload) {
            payload.map(function(service, i) {
                if (service.menu_type == s_type) {
                    let products = service.list_products
                    products.map(function(product, j) {
                        if (product.item_type == p_type) {
                            resolve({"product_id": product.product_id, "denoms": product.list_denoms})
                        }
                    })
                }
            })
            resolve("")
        }).catch(function (err) {
            reject(err)
        });
    })
}

function get_denom_by_product_id(s_type, p_id) {
    return new Promise((resolve, reject) => {
        localforage.getItem('list_service').then(function (payload) {
            payload.map(function(service, i) {
                if (service.menu_type == s_type) {
                    let products = service.list_products
                    products.map(function(product, j) {
                        if (product.product_id == p_id) {
                            resolve({"product_id": product.product_id, "denoms": product.list_denoms})
                        }
                    })
                }
            })
            resolve("")
        }).catch(function (err) {
            reject(err)
        });
    })
}

function get_product_by_prefix(s_type, p_prefix) {
    return new Promise((resolve, reject) => {
        localforage.getItem('list_service').then(function (payload) {
            payload.map(function(service, i) {
                if (service.menu_type == s_type) {
                    let products = service.list_products
                    products.map(function(product, j) {
                        let prefixs = product.telco_prefix
                        prefixs.map(function(prefix, k) {
                            if (p_prefix.startsWith(prefix)) {
                                resolve(product)
                            }
                        })
                    })
                }
            })
            resolve("")
        }).catch(function (err) {
            reject(err)
        });
    })
}

export default {
    clear_data: clear_data,
    set_login_result: set_login_result,
    get_login_result: get_login_result,
    set_list_services: set_list_services,
    get_login_result: get_login_result,
    get_product: get_product,
    get_denom_by_prefix: get_denom_by_prefix,
    get_denom_by_product: get_denom_by_product,
    get_product_by_prefix: get_product_by_prefix,
    get_denom_by_product_id: get_denom_by_product_id
}


// WEBPACK FOOTER //
// ./src/helper/localdata.js